import React from 'react';
import ContentLoader from 'react-content-loader';
import PanelContainer from 'components/PanelContainer';
import MediaQuery from 'react-responsive';

const ReviewContentLoader = props => (
  <>
    <MediaQuery query="(min-width: 501px)">
      <PanelContainer
        styles={{
          height: '370px',
          padding: '45px',
        }}
      >
        <ContentLoader
          height={370}
          width={825}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="21" rx="0" ry="0" width="391" height="25" />
          <rect x="2" y="87" rx="0" ry="0" width="135" height="135" />
          <rect x="172" y="86" rx="0" ry="0" width="126" height="26" />
          <rect x="3" y="272" rx="0" ry="0" width="179" height="24" />
          <rect x="208" y="272" rx="0" ry="0" width="179" height="24" />
          <rect x="172" y="132" rx="0" ry="0" width="306" height="16" />
          <rect x="454" y="272" rx="0" ry="0" width="104" height="24" />
          <rect x="172" y="170" rx="0" ry="0" width="218" height="16" />
          <rect x="172" y="204" rx="0" ry="0" width="376" height="16" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>

    <MediaQuery query="(max-width: 500px)">
      <PanelContainer
        styles={{
          height: 'auto',
          padding: '45px',
          maxHeight: '500px',
        }}
      >
        <ContentLoader
          height={400}
          width={325}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="19" y="25" rx="0" ry="0" width="278" height="25" />
          <rect x="94" y="69" rx="0" ry="0" width="135" height="135" />
          <rect x="4" y="297" rx="0" ry="0" width="149" height="24" />
          <rect x="51" y="226" rx="0" ry="0" width="220" height="16" />
          <rect x="51" y="257" rx="0" ry="0" width="222" height="16" />
          <rect x="172" y="297" rx="0" ry="0" width="149" height="24" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>
  </>
);

export default ReviewContentLoader;
